<div *ngIf="selecionado">
  <app-objetivo-venda-cadastro
    [model]="selecionado"
    (buscar)="buscar($event)"
    [state]="state">
  </app-objetivo-venda-cadastro>
</div>
<div *ngIf="!selecionado">
  <app-objetivo-venda-filtro [filtros]="filtros"></app-objetivo-venda-filtro>
  <app-objetivo-venda-lista
    [filtros]="filtros"
    (exibir)="selecionar($event)"
    (definirFiltro)="definirFiltro()">
  </app-objetivo-venda-lista>
</div>